function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("style", null, ".security-icon{fill:url(#security);}"), /*#__PURE__*/React.createElement("radialGradient", {
  id: "security",
  x1: 35,
  y1: 8.1,
  x2: 35,
  y2: 62.1,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "50%",
  stopColor: "#038FC7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#7B00FF"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "security-icon",
  d: "M5273.1,2400.1v-2c0-2.8-5-4-9.7-4s-9.7,1.3-9.7,4v2c0,1.8,0.7,3.6,2,4.9l5,4.9c0.3,0.3,0.4,0.6,0.4,1v6.4     c0,0.4,0.2,0.7,0.6,0.8l2.9,0.9c0.5,0.1,1-0.2,1-0.8v-7.2c0-0.4,0.2-0.7,0.4-1l5.1-5C5272.4,2403.7,5273.1,2401.9,5273.1,2400.1z      M5263.4,2400c-4.8,0-7.4-1.3-7.5-1.8v0c0.1-0.5,2.7-1.8,7.5-1.8c4.8,0,7.3,1.3,7.5,1.8C5270.7,2398.7,5268.2,2400,5263.4,2400z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "security-icon",
  d: "M5268.4,2410.3c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h4.3c0.6,0,1-0.4,1-1c0-0.6-0.4-1-1-1H5268.4z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "security-icon",
  d: "M5272.7,2413.7h-4.3c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h4.3c0.6,0,1-0.4,1-1C5273.7,2414.1,5273.3,2413.7,5272.7,2413.7z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "security-icon",
  d: "M5272.7,2417h-4.3c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h4.3c0.6,0,1-0.4,1-1C5273.7,2417.5,5273.3,2417,5272.7,2417z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "security-icon",
  d: "M64.9,39.6H62v-8.1c0-6.6-5.4-12-12-12c-6.6,0-12,5.4-12,12v8.1h-2.9c-1,0-1.8,0.8-1.8,1.8v28.5c0,1,0.8,1.8,1.8,1.8     h29.8c1,0,1.8-0.8,1.8-1.8V41.4C66.7,40.4,65.9,39.6,64.9,39.6z M41.5,31.6c0-4.7,3.8-8.5,8.5-8.5c4.7,0,8.5,3.8,8.5,8.5v8.1h-17     V31.6z M63.2,68.1H36.8v-25h26.3V68.1z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "security-icon",
  d: "M48.2,57.4v5c0,1,0.8,1.8,1.8,1.8c1,0,1.8-0.8,1.8-1.8v-5c2-0.7,3.5-2.7,3.5-4.9c0-2.9-2.4-5.3-5.3-5.3     c-2.9,0-5.3,2.4-5.3,5.3C44.7,54.7,46.2,56.6,48.2,57.4z M50,50.7c1,0,1.8,0.8,1.8,1.8S51,54.2,50,54.2c-1,0-1.8-0.8-1.8-1.8     S49,50.7,50,50.7z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "security-icon",
  d: "M12.9,65.5v4.8c-2.3,0.9-3.8,3.3-3.3,5.9c0.4,2,2,3.6,4,4c3.4,0.7,6.3-1.8,6.3-5.1c0-2.3-1.5-4.2-3.5-4.9v-3h12.7     c0.3,0,0.6-0.2,0.6-0.6v-2.4c0-0.3-0.2-0.6-0.6-0.6H14.7C13.7,63.8,12.9,64.6,12.9,65.5z M14.7,76.9c-0.9,0-1.7-0.8-1.7-1.7     c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7C16.4,76.2,15.6,76.9,14.7,76.9z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "security-icon",
  d: "M16.4,40.9c2.3-0.8,3.9-3.2,3.4-5.9c-0.4-2-2-3.6-4-4c-3.4-0.7-6.3,1.8-6.3,5.1c0,2.2,1.4,4.1,3.4,4.9v4.8     c0,1,0.8,1.8,1.8,1.8h14.4c0.3,0,0.6-0.2,0.6-0.6v-2.4c0-0.3-0.2-0.6-0.6-0.6H16.4V40.9z M14.7,34.3c0.9,0,1.7,0.8,1.7,1.7     c0,0.9-0.8,1.7-1.7,1.7C13.8,37.7,13,37,13,36C13,35.1,13.8,34.3,14.7,34.3z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "security-icon",
  d: "M7.7,50.4c-3.2,0-5.8,3-5.1,6.3c0.4,2,2,3.6,4,4c2.7,0.5,5.1-1,5.9-3.3h16.5c0.3,0,0.6-0.2,0.6-0.6v-2.4     c0-0.3-0.2-0.6-0.6-0.6H12.6C11.9,51.9,10,50.4,7.7,50.4z M7.7,57.3c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7     c0.9,0,1.7,0.8,1.7,1.7C9.4,56.6,8.6,57.3,7.7,57.3z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "security-icon",
  d: "M87.1,45.7v-4.8c2.3-0.9,3.8-3.3,3.3-5.9c-0.4-2-2-3.6-4-4c-3.4-0.7-6.3,1.8-6.3,5.1c0,2.3,1.5,4.2,3.5,4.9v3H70.9     c-0.3,0-0.6,0.2-0.6,0.6v2.4c0,0.3,0.2,0.6,0.6,0.6h14.4C86.3,47.5,87.1,46.7,87.1,45.7z M85.3,34.3c0.9,0,1.7,0.8,1.7,1.7     c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7C83.6,35.1,84.4,34.3,85.3,34.3z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "security-icon",
  d: "M87.1,70.4v-4.8c0-1-0.8-1.8-1.8-1.8H70.9c-0.3,0-0.6,0.2-0.6,0.6v2.4c0,0.3,0.2,0.6,0.6,0.6h12.7v3     c-2.3,0.8-3.9,3.2-3.4,5.9c0.4,2,2,3.6,4,4c3.4,0.7,6.3-1.8,6.3-5.1C90.5,73,89.1,71.1,87.1,70.4z M85.3,76.9     c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7C87,76.2,86.2,76.9,85.3,76.9z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "security-icon",
  d: "M93.4,50.5c-2.7-0.5-5.1,1-5.9,3.3H70.9c-0.3,0-0.6,0.2-0.6,0.6v2.4c0,0.3,0.2,0.6,0.6,0.6h16.5c0.7,2,2.6,3.4,4.9,3.4     c3.2,0,5.8-3,5.1-6.3C97,52.5,95.3,50.9,93.4,50.5z M92.3,57.3c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7     c0.9,0,1.7,0.8,1.7,1.7C94,56.6,93.2,57.3,92.3,57.3z"
});

function SvgSecurity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.26857233.svg";
export { ForwardRef as ReactComponent };